import type { MonospaceFile, MonospaceFileBase } from '#layers/data-model';
import { joinURL } from 'ufo';

export interface GetAssetURLOptions {
	apiBase: string;
	projectSlug?: string;
}

export function getAssetURL(file: MonospaceFile, options: GetAssetURLOptions): string;
export function getAssetURL(assetId: string, options: GetAssetURLOptions): string;
export function getAssetURL(idOrFile: string | MonospaceFile, options: GetAssetURLOptions): string;

export function getAssetURL(idOrFile: string | MonospaceFile, options: GetAssetURLOptions) {
	const { apiBase, projectSlug } = options;
	const assetId = typeof idOrFile === 'string' ? idOrFile : idOrFile.id;

	return joinURL(apiBase, projectSlug ?? 'system', 'assets', assetId);
}

/**
 * Type guard to distinguish MonospaceFile from SystemMonospaceFile (MonospaceFileBase).
 * MonospaceFile has additional title, description, and tags fields.
 */
export function isMonospaceFile(file: MonospaceFileBase): file is MonospaceFile {
	return 'title' in file || 'description' in file;
}
